import { ModalBody, Modal, ModalContent, ModalFooter, useDisclosure, Button, Input } from "@heroui/react"
import { useEffect, useRef, useState } from "react"
import { useFetchWithBody, usePost } from "../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, getModMandatory } from "../constants/enum"
import { toast } from "react-toastify"

const ConfirmBox = ({ handleConfirmBox, actionType }) => {
    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()

    const inpref = useRef(null)
    const [admKey, setAdmkey] = useState("")
    const [securitySetting, setSecuritySetting] = useState(false)
    const [msg, setMsg] = useState("")

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingSecurity",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })

    // useEffect(() => {
    //     if (modSetting && modSetting.length > 0) {
    //         const secSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.SecuritySetting, modSetting);
    //         setSecuritySetting(secSetting)
    //     }
    // }, [modSetting])


    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const secSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.SecuritySetting, modSetting);
            setSecuritySetting(secSetting)
            if (!secSetting && actionType === ENUM_PAGEACTION_TYPE.Edit) {
                handleConfirmBox(true);
                onOpenReportModelChange(); // close modal if open
            }
        }
    }, [actionType, modSetting]);


    const { isPending, data: admData = [], mutate: funValidateKey } = usePost({
        url: apiRoute.fetchAdmPassword,
        queryKey: "fetchAdmData",
        onSuccessTasks: ((data) => {
            setMsg("")
            if (data && data.length > 0) {
                if (data[0].keyMatch == 1) {
                    handleConfirmBox(true)
                    onOpenReportModelChange();
                }
                else {
                    setMsg("Invalid Auhtentication Key")
                }
            }
            else {
                handleConfirmBox(false)
                onOpenReportModelChange();
            }
        })

    })
    const handleSubmit = (e) => {
        e.preventDefault()
        if (admKey != "" && admKey != null) {
            funValidateKey({
                data: {
                    adm_key: admKey
                }
            })
        }
        else {
            setMsg("Authentication Key Required")
            if (inpref.current)
                inpref.current.focus();
        }

    }

    const handleDelete = () => {

        handleConfirmBox(true)
        onOpenReportModelChange();
    }

    const handleOnClose = () => {
        handleConfirmBox(false);
        onOpenReportModelChange();
    }

    useEffect(() => {
        onOpenReportModelChange()
    }, [handleConfirmBox])



    return (
        <div>
            <Modal
                isOpen={isOpenReportModel}
                onOpenChange={onOpenReportModelChange}
                size= {securitySetting?"sm":"xs"}
                placement="center"
                backdrop="transparent"
                isDismissable={false}
                hideCloseButton={true}
            >
                <ModalContent>
                    {(onClose) =>
                        securitySetting ? (
                            <>
                                <form onSubmit={handleSubmit}>

                                    <ModalBody className="overflow-auto border-t-4 border-rose-500">
                                        {/* <div className="flex  item-center justify-around text-sm mt-5 mb-2" > Sure ! You Want To Delete?</div> */}
                                        <div className=" text-green-700 font-semibold item-center justify-around text-xs mt-3 " >
                                            Enter Authentication Key To Confirm <span className="text-rose-500"> {actionType} </span> Action</div>
                                        <div className="text-red-500 text-sm" >{msg}</div>
                                        <div className="p-1 bg-red-100">
                                            <Input ref={inpref} type="password" size="sm" color="danger" variant="underlined" className="bg-white" isRequired value={admKey} onChange={
                                                (e) => setAdmkey(e.target.value)
                                            } name="admKey" ></Input>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button color="warning" type="submit" size="sm" variant="bordered"  >
                                            Confirm Action

                                        </Button>

                                        {/* <Button color="warning" onPress={handleDelete} size="sm" variant="bordered"  >
                                    Yes Delete !
                                   
                                </Button> */}
                                        <Button color="danger" size="sm" variant="bordered" onPress={handleOnClose}>
                                            Cancel
                                        </Button>
                                    </ModalFooter>


                                </form>
                            </>

                        ) : actionType === ENUM_PAGEACTION_TYPE.Delete ? (<>
                            <ModalBody className="overflow-auto border-t-4 border-rose-500">
                                <div className="flex  item-center justify-around text-sm mt-5 mb-2" > Sure ! You Want To Delete?</div>

                            </ModalBody>
                            <ModalFooter>


                                <Button color="warning" onPress={handleDelete} size="sm" variant="bordered"  >
                                    Yes Delete !

                                </Button>
                                <Button color="danger" size="sm" variant="bordered" onPress={handleOnClose}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </>) : null
                    }

                </ModalContent>
            </Modal>
        </div>
    )
}
export default ConfirmBox